exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".add-representant .custom-select {\n  min-width: 300px; }\n  .add-representant .custom-select label {\n    color: #777777; }\n\n@media only screen and (max-width: 568px) {\n  .add-representant .custom-select {\n    min-width: 150px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/representants/add/index.scss
// module id = 1214
// module chunks = 0